import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { getImageCustomName } from '../../../../constants/images';
import { SVGIconType } from '../../../../constants/svgIcon';
import i18n, { TranslationLocale } from '../../../../i18n';
import { getUiLocale } from '../../../../utils/i18n';
import { SvgIcon } from '../../../Molecules';

import styles from './WebStoreReferralRewardDetailTemplate.module.css';

export const WebStoreReferralRewardDetailTemplate = memo(() => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <SvgIcon
          name={SVGIconType.Referral}
          width={80}
          height={80}
          color={'black'}
        />
        <h1 className={styles.headerTitle}>{t('Referral Reward')}</h1>
        <img
          className={styles.stepImage}
          src={getImageCustomName(
            getUiLocale(i18n.language as TranslationLocale),
            'ForReferralRewards_img1',
          )}
        />
      </header>

      <div className={styles.info}>
        <section className={styles.referralRewardSection}>
          <SvgIcon
            name={SVGIconType.Person}
            width={80}
            height={80}
            color="#4D6EB4"
            stroke="white"
          />
          <h2 className={styles.referralRewardSectionTitle}>
            {t('Tier 1 Referral')}
          </h2>
          <p className={styles.text}>
            {t(
              'New users who use your referral link and complete the product payment will become your Tier 1 Referrals.',
            )}
          </p>
          <p className={styles.text}>
            {t(
              'For each Tier 1 Referral, you can receive 10% of the total net sales.',
            )}
          </p>
        </section>

        <section className={styles.usingWEACashSection}>
          <SvgIcon
            name={SVGIconType.Person}
            width={80}
            height={80}
            color="#1e89c7"
            stroke="white"
          />
          <h2 className={styles.usingWEACashSectionTitle}>
            {t('Tier 2 Referral')}
          </h2>
          <p className={styles.text}>
            {t(
              'New users referred by your Tier 1 Referrals become your Tier 2 Referrals.',
            )}
          </p>
          <p className={styles.text} />
          <p className={styles.text}>
            {t(
              'For each Tier 2 Referral, you can receive 5% of the total net sales.',
            )}
          </p>

          {/* <img
              className={styles.usingWEACashBanner}
              src={getImageCustomName(
                getUiLocale(i18n.language as TranslationLocale),

              )}
            /> */}
        </section>
      </div>

      <div className={`${styles.howToRefer}`}>
        <h2 className={styles.howToReferTitle}>{t('How to Refer')}</h2>
        <div className={styles.step}>
          <img
            className={styles.stepImage}
            src={getImageCustomName(
              getUiLocale(i18n.language as TranslationLocale),
              'ForReferralRewards_img2',
            )}
          />
        </div>
        <div className={styles.step}>
          <p className={styles.stepText}>
            {t(
              'Click “Share & Refer” on the product page to share the link to your friends.',
            )}
          </p>
        </div>
        <div className={styles.step}>
          <img
            className={styles.stepImage}
            src={getImageCustomName(
              getUiLocale(i18n.language as TranslationLocale),
              'ForReferralRewards_img3',
            )}
          />
        </div>
        <div className={styles.step}>
          <p className={styles.stepText}>
            {t(
              'Your friends will be able to purchase the product at a reduced price.',
            )}
          </p>
        </div>
        <div className={styles.step}>
          <img
            className={styles.stepImage}
            src={getImageCustomName(
              getUiLocale(i18n.language as TranslationLocale),
              'ForReferralRewards_img4',
            )}
          />
        </div>
        <div className={styles.step}>
          <p className={styles.stepText}>
            {t(
              'When your referred friends purchase the product, you will be eligible for a referral reward.',
            )}
          </p>
        </div>
      </div>
    </div>
  );
});
